var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"opacity"}},[(_vm.tasks != 0)?_c('div',{staticClass:"overlay"},[_c('v-icon',{staticStyle:{"font-size":"60px"},attrs:{"color":"white","x-large":""}},[_vm._v("fas fa-spinner fa-spin")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }